import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MenuForm from "./MenuForm";
import { updateMenu, getMenuById } from "../../api/MenuService";

export default function MenuEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.menuId;

  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      navigate("/menu");
      return;
    }
    fetchMenu();
  }, [id]);

  const fetchMenu = async () => {
    try {
      const res = await getMenuById(id);
      setMenuData(res?.data || res);
    } catch (error) {
    } finally {
      setPageLoading(false);
    }
  };

  const handleUpdate = async (formData) => {
    setLoading(true);

    try {
      const res = await updateMenu(id, formData);

      return res; // 

    } catch (error) {
      return error?.response?.data;
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return <div className="text-center mt-4">Loading menu details...</div>;
  }

  return (
    <MenuForm
      isEdit={true}
      loading={loading}
      onSubmit={handleUpdate}
      initialData={{
        name: menuData?.name || "",
        slug: menuData?.slug || "",
        type: menuData?.type || "",
        icon: menuData?.icon || "",
        parentId: menuData?.parentId || "",
        metaTitle: menuData?.metaTitle || "",
        metaKeywords: Array.isArray(menuData?.metaKeywords)
          ? menuData.metaKeywords.join(", ")
          : menuData?.metaKeywords || "",
        metaDescription: menuData?.metaDescription || "",
      }}
    />
  );
}